export const ENV_CONFIG = {
  APP_VERSION: __APP_VERSION__,
  ENV: __ENV__,
  IS_DEV: __ENV__ === 'local' || __ENV__ === 'development',
  IS_PROD: __ENV__ === 'production',
} as const;
